import { forwardRef, useEffect } from "react"
import { motion, useMotionValue } from "framer-motion"
import styled from "@emotion/styled"

import { useViewport } from "contexts/Viewport"

import getMediaQuery from "css/breakpoints"
import { buttonIcon, translucentDark } from "css/buttons"
import { fullGrid } from "css/grid"

import { Icon } from "components/icon/Icon"

import { useValue } from "./context"
import { useDictionary } from "contexts/Dictionary"

const ArrowsContainer = styled(motion.div)`
  /* ${fullGrid} */
  display: grid;
  grid-template-columns: [prev] calc(var(--outer-margin) - var(--grid-gap)) auto [next] calc(var(--outer-margin) - var(--grid-gap));
  grid-column: doc;
  grid-row: roller;
  z-index: 1;
  pointer-events: none;
  height: fit-content;
  transform: translateY(-50%);

  grid-row: 1;
  grid-column: 1;
`

const Arrow = styled(motion.button)`
  --arrow-size: 40px;
  ${getMediaQuery("m")} {
    --arrow-size: 44px;
  }
  ${buttonIcon}
  ${translucentDark}

  pointer-events: all;
  display: flex;
  border: 0;
  border-radius: 50%;

  width: var(--arrow-size);
  height: var(--arrow-size);

  justify-self: center;

  &.previous {
    grid-column: prev / span 1;
  }
  &.next {
    grid-column: next / span 1;
  }
  &.previous svg {
    transform: scale(-1);
  }
  &.previous:dir(rtl) svg {
    transform: scale(1);
  }
  &.next:dir(rtl) svg {
    transform: scale(-1);
  }
`

function Arrows({ scrollX }, ref) {
  const dictionary = useDictionary()

  const { outerMargin } = useViewport()

  const { dir, unit, assetCenter, max } = useValue()

  const scroll = v => {
    ref.current.scrollBy({
      top: 0,
      left: v * dir.get(),
      behavior: "smooth",
    })
  }

  const onPrevious = () => scroll(-unit.get() * 1.5)
  const onNext = () => scroll(unit.get() * 1.5)

  const prevVisible = useMotionValue("hidden")
  const nextVisible = useMotionValue("visible")

  const onScroll = x => {
    if (x * dir.get() < outerMargin.get()) {
      prevVisible.set("hidden")
    } else {
      prevVisible.set("visible")
    }
    if (x * dir.get() >= max.get()) {
      nextVisible.set("hidden")
    } else {
      nextVisible.set("visible")
    }
  }
  useEffect(() => scrollX.onChange(onScroll))

  return (
    <ArrowsContainer style={{ marginTop: assetCenter }} className='dark-theme'>
      <Arrow aria-label={dictionary.previous()} className='previous' onClick={onPrevious} style={{ visibility: prevVisible }} tabIndex={-1}>
        <Icon type={"moveNext"} />
      </Arrow>
      <Arrow aria-label={dictionary.next()} className='next' onClick={onNext} style={{ visibility: nextVisible }} tabIndex={-1}>
        <Icon type={"moveNext"} />
      </Arrow>
    </ArrowsContainer>
  )
}

export default forwardRef(Arrows)
